import { Injectable } from '@angular/core';
import { FormLoginComponent } from './form-login.component';
import { DialogLoginComponent } from '../dialog/dialog-login.component';
import { MatDialog } from '@angular/material';

@Injectable()
export class FormLoginService {
    constructor(
        private dialog: MatDialog,
    ) {
     }

    openLoginDialog(params) {
        return this.dialog.open(DialogLoginComponent, {
            width: '500px',
            height: '350px',
            data: {
                titleDialog: 'Login',
                titleButton: 'Entrar',
                component: FormLoginComponent,
                domain: params,
                contentDialogClassName: 'ps-login-content'
            },
            autoFocus: false
        });
    }
}
